import { useAuth } from '@context/AuthContext'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const HomePage: React.FC = () => {
	const navigate = useNavigate()
	const { user } = useAuth()

	// For now, redirect to trips page
	React.useEffect(() => {
		navigate('/trips', { replace: true })
	}, [navigate])

	return (
		<div style={{ padding: '2rem', textAlign: 'center' }}>
			<h1>Welcome back, {user?.firstName}!</h1>
			<p>Redirecting to your trips...</p>
		</div>
	)
}

export default HomePage
